import { styled } from '@mui/material/styles';

const ButtonGroup = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

export default ButtonGroup;
